import React from 'react';
import LoaderImage from '../../assets/images/icons/refreshIcon.svg';
import PropTypes from 'prop-types';
import { StyledLoader } from './style';

const MiniLoader = (props) => {
  return <StyledLoader src={LoaderImage} alt={``} {...props} />;
};

export default MiniLoader;

MiniLoader.propTypes = {
  width: PropTypes.string,
};
